(function() {
    'use strict';

    class UserActivityService {
        constructor($http, ICM_WARPZONE_PRODUCER_URL) {
            this.$http = $http;
            this.ICM_WARPZONE_PRODUCER_URL = ICM_WARPZONE_PRODUCER_URL;
        }

        postToWarpzone(assetType, assetId) {
            const payload = {
                assetType: assetType
            };

            if(assetId) {
                payload.assetId = assetId;
            }

            return this.$http.post(`${this.ICM_WARPZONE_PRODUCER_URL}/user-activity`, payload);
        }

        trackOutreachListPage() {
            const assetType = 'outreach-list';

            return this.postToWarpzone(assetType);
        }
    }

    angular
        .module('MW.Influencers.UserActivityService', [
            'MW.Configuration',
        ])
        .service('UserActivityService', [
            '$http',
            'ICM_WARPZONE_PRODUCER_URL',
            UserActivityService
        ]);
})();